import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './DBDropDown.module.css';


class DBDropDownPDCWeight extends React.Component {

    updateField(event) {
        if (this.props.onChange) {
            this.props.onChange(event);
        }
        if (!event.isPropagationStopped()) {
            if (event.target.value === '-1') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            }
            else {
                this.props.updateIntField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseInt(event.target.value));
            }
        }
    }
    render() {
        return (

            <div className={`${styles.dropdown} ${this.props.className}`}>
                <select
                    title={this.props.title}
                    value={this.props.value !== undefined ? this.props.value : -1}
                    name={this.props.field}
                    className={this.props.className}
                    disabled={this.props.disabled}
                    onChange={(event) => this.updateField(event)}
                >
                    <option key={-1} value={-1}></option>

                    {!this.props.customOptions &&
                        Object.keys(this.props.options)
                            .map(id => {
                                const option = this.props.options[id];
                                return (
                                    <option key={option.DWNO} value={option.DWNO}>{option.DWNAME}</option>
                                );
                            })
                    }
                </select>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateIntField: bindActionCreators(noteActions.updateIntField, dispatch),
        updateTextField: bindActionCreators(noteActions.updateTextField, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);

    let masterFieldKey = noteType === 1 ?
        state.entities.notes.PTEVAL[pk][ownprops.masterField] :
        state.entities.notes.PTNOTE[pk][ownprops.masterField];

    let optionKeys = Object.keys(state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF)
        .filter(x => state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF[x].WFXDWFNO === masterFieldKey)
        .sort((a, b) => state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF[b].WFXORDER > state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF[a].WFXORDER ? -1 : 1)
        .map(key => state.entities.masterData.PTMASTERWCDOLPDCWEIGHTFREQXREF[key].WFXDWNO);

    let options = Object.keys(state.entities.masterData.PTMASTERWCDOLPDCWEIGHT)
        .filter(x => optionKeys.includes(state.entities.masterData.PTMASTERWCDOLPDCWEIGHT[x].DWNO))
        .map(key => state.entities.masterData.PTMASTERWCDOLPDCWEIGHT[key]);

    return {
        value: (state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined &&
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : -1),
        options

    };
}

const connectedDBDropDownPDCWeight = connect(mapStateToProps, mapDispatchToProps)(DBDropDownPDCWeight);
export { connectedDBDropDownPDCWeight as DBDropDownPDCWeight };